// @ts-nocheck

export type TicketGetWithRoom = typeof TicketGetWithRoom[keyof typeof TicketGetWithRoom];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithRoom = {
  true: 'true',
  false: 'false',
} as const;
